module.exports = __webpack_public_path__ + "img/seal-check.56c7de3d.svg";